import App from "@/views/App.vue";

export default [
  {
    path: "/novo-post",
    name: "newPost",
    component: App,
    redirect: { name: "newPostHome" },
    children: [
      {
        path: "/novo-post/:id?",
        name: "newPostHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewPost.vue"),
        meta: {
          displayName: "Novo Post - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-post/:id",
        name: "editPost",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditPost.vue"),
        meta: {
          displayName: "Novo Post - Exclusive Lounge",
          requiresAuth: true,
        },
      },
    ],
  },
];
